import React, { useState } from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import CodeMailCheckFormContent from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/CodeMailCheckFormContent";
import useValidationSchemaMailCode, { CheckMailCode } from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/useValidationSchemaMailCode";
import { AxiosError } from "axios";

export type VerificationMailFormProps = {
  initialValues: CheckMailCode;
  stepPrecedente: () => void;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
  submitFormAPI: (values: CheckMailCode) => Promise<void>;
  askForPassword?: boolean;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};


const CodeMailCheckForm = ({ initialValues, stepPrecedente, submitSuccessHandler, submitFormAPI, askForPassword, displayCancelBtn, cancelCallback }: VerificationMailFormProps) => {
  const validationSchema = useValidationSchemaMailCode(askForPassword);
  const [customError, setCustomError] = useState<AxiosError | undefined>();

  const handleCustomError = (err: AxiosError | undefined) => {
    setCustomError(err);
  }

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={submitFormAPI}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
      customError={customError}
    >
      <CodeMailCheckFormContent
        stepPrecedente={stepPrecedente}
        askForPassword={askForPassword}
        setCustomError={handleCustomError}
        displayCancelBtn={displayCancelBtn}
        cancelCallback={cancelCallback}
      />
    </AppFormik>
  );
};

export default CodeMailCheckForm;